import service from '../index';
import config from '@/assets/config.json';

// 获取商品标准名称
export function standardList(data) {
    const url = config.develop.api + '/goodsManage/getStandardNameList'
    return service.post(url, data)
}

// 获取店铺
export function shopList(data) {
    const url = config.develop.api + '/goodsManage/getLocalShop'
    return service.post(url, data)
}

// 查询品控列表
export function getGoodsCreditList(data) {
    const url = config.develop.api + '/goodsManage/getGoodsCreditList'
    return service.post(url, data)
}

// 品控详情
export function getGoodsCreditDetail(data) {
    const url = config.develop.api + '/goodsManage/getGoodsCreditDetail'
    return service.post(url, data)
}

// 品控优化建议
export function getGoodsAdvicePropertyList(data) {
    const url = config.develop.api + '/goodsManage/getGoodsAdvicePropertyList'
    return service.post(url, data)
}

// 查询交易量统计
export function getGoodsOrderAnalysisList(data) {
    const url = config.develop.api + '/goodsManage/getGoodsOrderAnalysisList'
    return service.post(url, data)
}

// 查询访问量统计
export function getGoodsAccessAnalysisList(data) {
    const url = config.develop.api + '/goodsManage/getGoodsAccessAnalysisList'
    return service.post(url, data)
}


